<template>
    <div>
        <swb-result-table name="result_table" ref="result_table" :config="resultConfig" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName"
                          :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight"></swb-result-table>
    </div>
</template>

<script>
import {Utils} from '../../app.base'
import {MsgBox} from '../../app.vues'

import esignBizFormApi from '../../api/esignBizForm'

export default {
    name: 'swb-esign-def-seal-for-select',
    desc: '查询被外部企业授权印章',
    props: {
        esignOrgId: {
            type: String,
            default: null
        },
        mainCom: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            theTableHeight: 550,
            resultConfig: {
                colList: [{
                    "name": "sealName",
                    "text": "印章名称",
                    "dataType": "string",
                    "width": null,
                    "align": "left",
                    "overflowAsTip": true,
                    "format": null,
                    "asTpl": false
                }, {
                    "name": "sealId",
                    "text": "印章编号",
                    "dataType": "string",
                    "width": null,
                    "align": "left",
                    "overflowAsTip": true,
                    "format": null,
                    "asTpl": false
                }, {
                    "name": "sealImageDownloadUrl",
                    "text": "印章图片",
                    "dataType": "string",
                    "width": null,
                    "align": "center",
                    "overflowAsTip": true,
                    "format": null,
                    "asTpl": false
                }]
            },
            //
            needPager: false, //是否需要分页（默认：true）
            multiSelect: false, //是否多选（默认：false）
            multiPageSelect: false, //是否要多页/跨页选择（默认：false）
            rowKeyPropName: 'sealId', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
            rowNoShow: true, //是否显示行号（默认：true）
            rowNoFixed: true, //行号列是否固定（默认：false）
            //
            btnColName: '',//操作列名称（如果不设置就不显示操作列）
            btnColTitle: '操作',//操作列标题（默认：'操作'）
            btnColWidth: 100,//操作列宽度（默认：100）
            btnColFixed: true, //操作列是否固定
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {}
            },
            dataList: []
        }
    },
    created: function () {
        //
        this.getDataList();
    },
    mounted() {
        //
        this.initResultTable();
        //回显数据处理
        let initChecked = this.selectStdValues || [];
        if (!Utils.isNoB(initChecked) && initChecked.length > 0) {
            let resultTable = this.$refs.result_table;
            resultTable.setInitChecked(initChecked, false);
        }
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if (domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },
    methods: {
        initResultTable() {
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            //
            resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                'sealImageDownloadUrl': function (row, colName, colValue, rowIndex, colConf) {
                    if (!Utils.isNoB(row.sealImageDownloadUrl)) {
                        return '<a href="#"><img style="height: 36px;width: 36px" src="' + row.sealImageDownloadUrl + '"/></a>';
                    } else {
                        return '';
                    }
                },
                'actions': function (row, colName, colValue, rowIndex) {
                    return '';
                }
            }, /* 单元格按钮点击处理函数 */{
                //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                'actions': function (row, colName, colValue, rowIndex, btnName) {
                }
            });
        },
        renderTable(rows, pagination) {
            let resultTable = this.$refs.result_table;
            //清除数据（如果已经渲染的数据与新的列不是一回事儿）
            //resultTable.clear();
            //同步使用新的自定义列信息
            //resultTable.initMeta(confColList);
            let tableData = {
                rows: rows,
                pagination: pagination
            };
            resultTable.render(tableData);
        },
        getDataList() {
            let postData = {
                esignOrgId: this.esignOrgId
            };
            if (this.mainCom) {
                let theLoading = MsgBox.loading();
                esignBizFormApi.getOrgOwnSealList(postData, (result) => {
                    theLoading.close();
                    if (result.type == 'info') {
                        //
                        this.renderTable(result.data || [], {});
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            } else {
                let theLoading = MsgBox.loading();
                esignBizFormApi.getOrgAuthorizedSealList(postData, (result) => {
                    theLoading.close();
                    if (result.type == 'info') {
                        //
                        this.renderTable(result.data || [], {});
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        },
        getTableSelection() {
            let resultTable = this.$refs.result_table;
            return resultTable.getSelection();
        },
        getDlgResult: function () {
            let esignSealInfo = this.getTableSelection() || [];
            //
            let result = {
                type: 'info'
            };

            // esignSealInfo.sealId = 22
            // esignSealInfo.sealName = 22
            // esignSealInfo.sealBizType = 5
            // esignSealInfo.sealImageDownloadUrl = 22
            // result.data = esignSealInfo;
            // return result

            if (esignSealInfo.length <= 0) {
                result.type = 'warn';
                result.message = '请选择签章';
            } else {
                result.data = esignSealInfo;
            }
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/order/EsignDefSealSelect.vue